import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-acc-transactions',
  templateUrl: './acc-transactions.component.html',
  styleUrls: ['./acc-transactions.component.css']
})
export class AccTransactionsComponent implements OnInit {

  constructor(public translate: TranslateService,
    public storage: LocalStorageService,) { }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
  Recv_Items(){
    this.storage.store('stgtype','11')
  }
  Ret_Items(){
    this.storage.store('stgtype','12')
  }
  Issue_Items(){
    this.storage.store('stgtype','20')
  }
  Refund_Items(){
    this.storage.store('stgtype','22')
  }
  Adjust_Items(){
    this.storage.store('stgtype','13')
  }
  Revenue(){
    this.storage.store('stgValue',0);
    this.storage.store('stgPatientCode','');
    this.storage.store('stgPatientName','');
  }
}
